import { Component, Inject, OnDestroy, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminScreenContextService } from '../admin/shared/admin-screen-context.service';

@Component({
    selector: 'gtw-users-component',
    templateUrl: './users-component.component.html',
    styleUrls: ['./users-component.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UsersComponentComponent implements OnInit, OnDestroy {

  title: string = '';
  displayName: string = '';
  rowData: any;
  minimised = false;
  activeTab = 0;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    @Optional() private dialogRef: MatDialogRef<UsersComponentComponent>,
    private adminScreenContext: AdminScreenContextService
  ) {
    this.rowData = data?.rowData || {};
    if (typeof data?.activeTab === 'number') {
      this.activeTab = data.activeTab;
    }
  }

  ngOnInit(): void {
    this.adminScreenContext.setRowData(this.rowData);
    const rd = this.rowData;
    const name = rd.DISPLAY_NAME || `${rd.FIRST_NAME || ''} ${rd.LAST_NAME || ''}`.trim();
    const sso = rd.user_id || rd.SSO_ID || rd.SSO || '';
    this.displayName = name && sso ? `${name} - ( ${sso} )` : name || sso || 'User Details';
  }

  ngOnDestroy(): void {
    // Clear only the row context. gridData is owned by the host page's
    // AdminGridDirective and must outlive this dialog so the host page
    // remains usable after the modal closes.
    this.adminScreenContext.setRowData({});
  }

  toggleMinimise(): void {
    this.minimised = !this.minimised;
    if (this.dialogRef) {
      if (this.minimised) {
        this.dialogRef.updateSize('90vw', 'auto');
      } else {
        this.dialogRef.updateSize('90vw');
      }
    }
  }

  cancel(): void {
    this.dialog.closeAll();
  }

  eventType(type: any): void {
    if (type === 'cancel') {
      this.cancel();
    } else {
      this.title = type;
    }
  }
}
